import {useContext, useEffect} from "react";
import {Context} from "./Context";
import "./Style.css"
import {includes, Translator} from "../../component/ForTrans";

export default function SubmitMetaData() {
    const {metaData, setMetaData} = useContext(Context);
    useEffect(() => {
        console.log(metaData);
    }, [metaData]);


    const changeTranslators = (value) => {
        let trans = [...metaData.translator]
        if (includes(trans, value)) setMetaData(prev => ({...prev, translator: trans.filter(it => it !== value)}))
        else if (trans.length === 4) alert("최대 4개만 선택 가능합니다.")
        else if (!Array.isArray(trans)) setMetaData(prev => ({...prev, translator: [value]}))
        else {
            trans.push(value)
            setMetaData(prev => ({...prev, translator: trans}))
        }
    }

    return <div className='w-full overflow-x-scroll templates' id='trans'>
        번역
        <table className="overflow-x-auto p-4 [&_tr]: m-4">
            <thead className="bg-gray-100">
            <tr>
                <th className="px-4 py-4 border text-xl">사용 가능 AI</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td className="px-4 py-4 border text-xl">
                    {Translator.map((it, index) =>
                        (<label key={`Create Trans SubmitMetaData checkBox ${index}`}>
                            <input type="checkbox" style={{height: "auto"}}
                                checked={includes(metaData.translator, it)}
                                onChange={() => changeTranslators(it)}/>
                            {it}
                        </label>))}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
}
